<template>
  <b-tabs
    v-model="tabIndex"
    content-class="mt-1"
  >
    <!-- This tabs content will always be mounted -->
    <b-tab
      title="Listado de productos"
      lazy
    >
      <products-list
        @addProductTab="newTab($event)"
      />
    </b-tab>

    <!-- This tabs content will not be mounted until the tab is shown and will be un-mounted when hidden -->
    <b-tab
      v-for="product in productsTabs.filter(product => product.type === 'view')"
      :key="product.id"
      :title="'Producto #' + product.id"
      lazy
    >
      <products-view
        :product-id="product.id"
        @closeTab="closeTab(product.id, 'view')"
      />
    </b-tab>

    <!-- Close tab button -->
    <template
      v-if="productsTabs.length > 0"
      #tabs-end
    >
      <b-nav-item
        @click.prevent="closeTab(productsTabs[0].id, productsTabs[0].type)"
      >
        <b>x</b>
      </b-nav-item>
    </template>

  </b-tabs>
</template>

<script>
import ProductsList from './ProductsList.vue'
import ProductsView from './ProductsView.vue'

export default {
  components: {
    ProductsList,
    ProductsView,
  },

  data() {
    return {
      tabIndex: 0,
      productsTabs: [],
    }
  },

  watch: {
    '$route.params.id': function routeParamsIdWatcher(newId) {
      if (newId) {
        this.newTab(Number(newId))
      }
    },
  },

  mounted() {
    if (this.$route.params.id) {
      this.newTab(Number(this.$route.params.id))
    }
  },

  methods: {
    newTab(productId) {
      this.productsTabs = []
      this.productsTabs.push({
        id: productId,
        type: 'view',
      })
      setTimeout(() => {
        this.tabIndex = 1
      }, 100)
    },

    closeTab(productId, type) {
      for (let i = 0; i < this.productsTabs.length; i += 1) {
        if (this.productsTabs[i].id === productId && this.productsTabs[i].type === type) {
          this.productsTabs.splice(i, 1)
        }
      }
      this.tabIndex = 0 // Redirect to list component
    },
  },
}
</script>
